export default __webpack_public_path__ + "static/media/custom-orders.ff3e1512.svg";